<template src="./archivioVecchiClienti.html"></template>

<script>
// Archivio storico dei clienti non piu' attivi (solo admin): consultazione, gestione (sposta, rinomina,
// elimina) e ripristino dell'intera cartella di un cliente tra quelle attive.
import {
    get_file,
    getFileCliente,
    download_file,
    ripristina_cliente,
    elimina_file,
    elimina_cartella,
} from "@/api/api.dati.js";

import DialogAnteprimaDocumento from "@/components/dialog/DialogAnteprimaDocumento.vue";
import DialogRenameDirectory from "@/components/dialog/DialogRenameDirectory.vue";
import DialogSpostaElemento from "@/components/dialog/DialogSpostaElemento.vue";

const RADICE = "ArchivioVecchiClienti";

export default {
    components: { DialogAnteprimaDocumento, DialogRenameDirectory, DialogSpostaElemento },

    data: () => ({
        listaDati: [],
        selectedItem: -1,
        selectedRow: null,
        posizioneUrl: "",
        flagStyle: true,
        loading: false,

        dialogAnteprima: false,
        elementoAnteprima: null,

        dialogRenameDir: false,
        DirectoryRename: null,

        dialogSposta: false,
        elementoDaSpostare: null,

        ricercaRagioneSociale: "",
    }),

    methods: {
        radiceConPosizione() {
            return this.posizioneUrl ? `${RADICE}/${this.posizioneUrl}` : RADICE;
        },

        // Ricarica la cartella corrente (percorso relativo costruito dalla posizione).
        async ricarica() {
            this.loading = true;
            this.selectedRow = null;
            this.listaDati = [];

            const res = await get_file({ path: this.radiceConPosizione(), refresh: false });
            this.listaDati = res.data || [];
            this.orderListaCartelle();

            this.loading = false;
        },

        orderListaCartelle() {
            this.listaDati.sort((a, b) => {
                if (!a.cliente && !b.cliente) return (a.nome || "").localeCompare(b.nome || "", "it", { sensitivity: "base" });
                if (!a.cliente) return 1;
                if (!b.cliente) return -1;
                return a.cliente.localeCompare(b.cliente, "it", { sensitivity: "base" });
            });
        },

        // Il percorso di un elemento e' "ArchivioVecchiClienti/<segmenti...>": la posizione mostrata
        // e' quel percorso senza la radice.
        impostaPosizione(percorso) {
            this.posizioneUrl = percorso.split("/").slice(1).join("/");
        },

        selectRow(item) {
            this.selectedRow = item;
            if (item.tipo !== "file") this.apriCartella(item);
        },

        async apriCartella(item) {
            this.loading = true;
            const res = await getFileCliente({ path: item.path });
            this.listaDati = res.data || [];
            this.orderListaCartelle();
            this.impostaPosizione(item.path);
            this.selectedItem = null;
            this.selectedRow = null;
            this.loading = false;
        },

        vaiAllaRadice() {
            this.posizioneUrl = "";
            this.ricarica();
        },

        async backDirectory() {
            if (this.inRadiceNavigazione) return;
            this.posizioneUrl = this.posizioneUrl.includes("/") ? this.posizioneUrl.slice(0, this.posizioneUrl.lastIndexOf("/")) : "";
            await this.ricarica();
        },

        anteprimaFile(oggetto) {
            if (oggetto.tipo != "file") return;
            const estensione = (oggetto.estensione || "").toLowerCase();
            if (estensione === ".docx" || estensione === ".xlsx" || estensione === ".xls" || estensione === ".csv") {
                this.elementoAnteprima = oggetto;
                this.dialogAnteprima = true;
                return;
            }
            let ur = oggetto.path.split("/").map(encodeURIComponent).join("/");
            window.open("https://www.wpcoc.it/data/" + ur, "_blank");
        },

        async scaricaFile(oggetto) {
            if (oggetto.tipo != "file") return;
            this.loading = true;
            let par = "?path=" + encodeURIComponent(oggetto.path);
            const response = await download_file(par);
            let tipoFile = oggetto.estensione ? oggetto.estensione.replace(".", "") : "";
            this.downloadFile(response.data, tipoFile, oggetto.nome + (oggetto.estensione || ""));
            this.loading = false;
        },

        downloadFile(data, tipoFile, nomeFile) {
            const mimeTypes = {
                pdf: "application/pdf", docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                doc: "application/msword", xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                xls: "application/vnd.ms-excel",
            };
            let blob = new Blob([data], { type: mimeTypes[tipoFile] || "application/octet-stream" });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = nomeFile;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        },

        // ----- Elimina -----
        async eliminaFile(oggetto) {
            let confirm = await this.$confirm.open(
                "Elimina",
                "Eliminare il file: <br><b>" + oggetto.nome + (oggetto.estensione || "") + "</b>?"
            );
            if (!confirm) return;

            const res = await elimina_file(oggetto, "?path=" + encodeURIComponent(oggetto.path));
            if (res.data == "OK") {
                this.$toast.info("File eliminato");
                await this.ricarica();
            } else {
                this.$toast.alert("Errore! Impossibile eliminare il file. " + res.data);
            }
        },

        async eliminaCartella(folder) {
            const nome = folder.cliente ? "<b>" + folder.nome + "</b> di <b>" + folder.cliente + "</b>" : "<b>" + folder.nome + "</b>";
            let confirm = await this.$confirm.open(
                "Elimina",
                "Eliminare la cartella: <br>" + nome + "?<br><br>Tutte le risorse al suo interno andranno perse."
            );
            if (!confirm) return;

            this.loading = true;
            const res = await elimina_cartella("?path=" + encodeURIComponent(folder.path));
            if (res.data == "OK") {
                this.$toast.info("Cartella eliminata");
                await this.ricarica();
            } else {
                this.$toast.alert("Errore nell'eliminazione della cartella " + folder.nome);
            }
            this.loading = false;
        },

        // ----- Rinomina -----
        apriRinomina(folder) {
            this.DirectoryRename = folder;
            this.dialogRenameDir = true;
        },

        chiusuraRinomina(folder, value) {
            this.DirectoryRename = null;
            this.dialogRenameDir = false;
            if (value !== -1) this.ricarica();
        },

        // ----- Sposta -----
        apriDialogSposta(elemento) {
            this.elementoDaSpostare = elemento;
            this.dialogSposta = true;
        },

        chiudiDialogSposta() {
            this.dialogSposta = false;
            this.elementoDaSpostare = null;
        },

        spostamentoCompletato() {
            this.chiudiDialogSposta();
            this.ricarica();
        },

        // ----- Ripristino -----
        async ripristinaCliente(folder) {
            let confirm = await this.$confirm.open(
                "Ripristina cliente",
                "Riportare la cartella di <b>" + (folder.cliente || folder.nome) + "</b> (con tutte le sottocartelle) tra gli archivi attivi?"
            );
            if (!confirm) return;

            this.loading = true;
            const res = await ripristina_cliente(folder.nome);
            if (res.data === "OK") {
                this.$toast.info("Cartella ripristinata");
                await this.ricarica();
            } else {
                this.$toast.alert(res.data);
            }
            this.loading = false;
        },
    },

    mounted() {
        this.ricarica();
    },

    created() {
        if (this.getRole != "admin") this.$router.push({ path: "/" });
    },

    computed: {
        getRole() {
            return this.$store.getters["user/getRole"];
        },

        radice() {
            return RADICE;
        },

        inRadiceNavigazione() {
            return this.posizioneUrl == "" || this.posizioneUrl == null;
        },

        listaDatiFiltrata() {
            if (!this.inRadiceNavigazione) return this.listaDati;
            const ricerca = (this.ricercaRagioneSociale || "").toLowerCase().trim();
            if (!ricerca) return this.listaDati;
            return this.listaDati.filter((item) => (item.cliente || "").toLowerCase().includes(ricerca));
        },
    },
};
</script>
